import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import moment from "moment";

const CustomDatePicker = (props) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear - 100; i <= currentYear + 10; i++) {
    years.push(i);
  }

  const handleChange = (date) => {
    props.handleChange(
      moment(date).format("DD-MMM-YYYY"),
      props.name,
      "datepicker"
    );
  };

  const handleClose = () => {
    if (props.required) {
      props.handleChange(props.value, props.name, "datepicker", ["required"]);
    }
  };

  return (
    <DatePicker
      customInput={<InputMask type="text" />}
      onCalendarClose={handleClose}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="input-group input-group-sm input-group-calendar">
          <div className="input-group-prepend">
            <button
              onClick={(e) => {
                e.preventDefault();
                decreaseMonth();
              }}
              disabled={prevMonthButtonDisabled}
              className="btn btn-outline-secondary"
              type="button"
            >
              {"<"}
            </button>
          </div>

          <select
            className="form-control"
            value={moment(date).year()}
            onChange={({ target: { value } }) => changeYear(Number(value))}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            className="form-control"
            value={
              months[(date instanceof Date ? date : new Date()).getMonth()]
            }
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <div className="input-group-append">
            <button
              onClick={(e) => {
                e.preventDefault();
                increaseMonth();
              }}
              className="btn btn-outline-secondary"
              disabled={nextMonthButtonDisabled}
            >
              {">"}
            </button>
          </div>
        </div>
      )}
      wrapperClassName={props.wrapperClassName}
      className="form-control"
      minDate={false}
      selected={
        props.value ? props.value : props.maxDate ? props.maxDate : new Date()
      }
      autoComplete="off"
      showIcon
      placeholderText={props.placeholderText}
      maxDate={props.maxDate}
      id={props.id}
      name={props.name}
      onChange={(date) => handleChange(date)}
      icon="fa fa-calendar"
      value={props.value}
    />
  );
};

export default CustomDatePicker;
